import { EmailVerificationForm } from "@/components";
import { useEmailVerification, useResendEmailVerificationCode } from "@/hooks";

import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const EmailVerification: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const otpRef = useRef<{ resetOtp: () => void }>(null);
  const { state } = useLocation();
  const email = state?.email;
  const { completeSignUp } = useEmailVerification(otpRef, setLoading, state);
  const { resendVerificationCode } = useResendEmailVerificationCode();

  return (
    <div className="container mx-auto py-13 px-8 md:px-6 max-w-6xl h-full">
      <EmailVerificationForm
        ref={otpRef}
        completeSignUp={completeSignUp}
        loading={loading}
        setLoading={setLoading}
        resendVerificationCode={resendVerificationCode}
        email={email}
      />
    </div>
  );
};

export default EmailVerification;
